import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/app/specials/[id]/page.tsx");
